
shadow.loader.set_load_start('shared-docgen');